import { Box } from '@mui/material'
import styled from '@emotion/styled'
import theme from 'theme'

export const Wrapper = styled(Box)<{ isSelected: string; isloading?: string }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${theme.colors.frameworkCardBg};
  gap: ${theme.spacing.small}px;
  padding: ${theme.spacing.small}px;
  border-radius: ${theme.attributes.borderRadius.secondary};
  height: 108px;
  width: 100%;

  ${({ isSelected }) =>
    isSelected === 'true' &&
    `
      background: ${theme.colors.tooltipBg};

      html[data-theme='light'] & {
        background: #f8ecf3;
      }
  `};

  &:hover {
    cursor: pointer;
    background: ${theme.colors.tooltipBg};

    html[data-theme='light'] & {
      background: ${theme.colors.menuItemHover};
    }

    ${({ isloading }) =>
      isloading &&
      isloading === 'true' &&
      `
        cursor: wait;
  `};
  }
`

export const CardHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .card-header-left {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.small}px;
    width: 100%;

    .icon-wrapper {
      position: relative;

      .unread-indicator {
        position: absolute;
        top: -5px;
        right: -5px;
        z-index: 2;
      }

      .card-icon {
        z-index: 1;
      }
    }

    .card-header-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: calc(100% - 72px);
      gap: ${theme.spacing.xSmall}px;

      .card-header-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .insight-header-text {
          flex-grow: 1;
          color: ${theme.colors.textSecondary};

          html[data-theme='light'] & {
            color: ${theme.colors.textCaption};
          }
          font-size: ${theme.typography.fontSize.small};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.thick};
          line-height: normal;
          letter-spacing: 1px;
          text-transform: uppercase;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-right: ${theme.spacing.xSmall}px;
        }

        .insight-date-text {
          color: ${theme.colors.textSecondary};
          font-size: ${theme.typography.fontSize.small};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.thick};
          line-height: normal;
          letter-spacing: 1px;
          text-transform: uppercase;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .insight-title-text {
        overflow: hidden;
        color: ${theme.colors.foreground};
        text-overflow: ellipsis;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.thin};
        line-height: normal;
        white-space: nowrap;
        width: 100%;
      }
    }
  }
`

export const CardFooter = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 24px;

  .card-footer-left {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
    width: 100%;

    svg {
      width: 20px;
      height: 20px;
      min-width: 20px;
    }

    .cpi-name-text {
      color: ${theme.colors.textSecondary};
      text-align: center;
      font-size: ${theme.typography.fontSize.small};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.thick};
      line-height: normal;
      letter-spacing: 1px;
      text-transform: uppercase;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
`

export const FooterDivider = styled(Box)`
  background: ${theme.colors.controlBorder};
  height: 20px;
  margin: 0 ${theme.spacing.small}px;
  width: 1px;
  flex-shrink: 0;

  html[data-theme='light'] & {
    background: #d1ccd0;
  }
`
